// frontend/src/components/WorkshopDashboard/MoneyRow.js
// Replaces the 3 gradient "Finances" StatCards. Count and amount together — the old
// dashboard showed "Devis en attente" twice (count in Activité, amount in Finances).

import { useNavigate } from 'react-router-dom';
import { IconChevron } from '../icons/Icons';

export default function MoneyRow({ health }) {
  const navigate = useNavigate();

  return (
    <div className="grid gap-px rounded-2xl border border-[#241F1B] bg-[#241F1B] overflow-hidden
                    [grid-template-columns:repeat(auto-fit,minmax(190px,1fr))]">
      {health.money.map(m => (
        <article key={m.key}
          className="bg-gradient-to-b from-[#17140F] to-[#131110] hover:bg-[#1A1613] transition-colors
                     px-[18px] py-4 flex flex-col gap-2.5">
          <div className="flex items-center justify-between gap-2">
            <span className="text-[10.5px] uppercase tracking-[.16em] text-[#6E665C] whitespace-nowrap min-w-0 overflow-hidden text-ellipsis">{m.label}</span>
            <span className="text-[9px] font-semibold uppercase tracking-[.1em] px-[7px] py-[3px] rounded-[5px] whitespace-nowrap shrink-0"
                  style={{ color: m.color, background: m.tint }}>
              {m.state}
            </span>
          </div>

          <div className="flex items-end gap-1.5">
            <span className="font-['Space_Grotesk',sans-serif] text-[26px] font-semibold leading-none tracking-[-.03em] tabular-nums whitespace-nowrap"
                  style={{ color: m.color }}>
              {m.amount}
            </span>
            <span className="text-xs text-[#8F877B] pb-0.5">FCFA</span>
          </div>

          <p className="text-[11px] text-[#7C7468]">{m.sub}</p>

          <button onClick={() => navigate(m.href)}
            className="mt-auto text-[11.5px] text-[#8F877B] hover:text-[#F4F1EA] flex items-center gap-1.5 whitespace-nowrap transition-colors">
            {m.cta}<IconChevron className="w-3 h-3 shrink-0" />
          </button>
        </article>
      ))}
    </div>
  );
}
